module.exports = __webpack_public_path__ + "img/profile.372b34ad.png";